import './assets/shared.css';const t = "cpMBIG_baseButton", s = "cpMBIG_destructive", c = "cpMBIG_ghost", e = "cpMBIG_primary", o = "cpMBIG_secondary", r = {
  baseButton: t,
  destructive: s,
  ghost: c,
  "night-aware": "cpMBIG_night-aware",
  primary: e,
  secondary: o
};
export {
  r as s
};
//# sourceMappingURL=shared.module-DBUqf3DR.js.map
